import { lazySelector } from '@phx-styleguides/core';

import { Drawers } from '@sg-core/src/View/Components/Organisms/Drawers';

export class CountrySelector {
  private el: HTMLElement;
  private formEl: HTMLFormElement;
  private inputEl: HTMLInputElement;
  private drawers: Drawers;

  constructor(el: HTMLElement | string, drawersEl: HTMLElement | string) {
    this.el = lazySelector(el);

    this.formEl = this.el.querySelector('form') as HTMLFormElement;
    this.inputEl = this.el.querySelector('input') as HTMLInputElement;

    if (!this.inputEl) {
      throw new Error('Input element not found');
    }

    this.inputEl.addEventListener('input', this.onInput.bind(this));
    this.formEl?.addEventListener('submit', this.preventDefault.bind(this));

    this.drawers = new Drawers(drawersEl);
  }

  private preventDefault(event: Event) {
    event.preventDefault();
  }

  private onInput(event: Event) {
    this.drawers.reset();

    const input = event.target as HTMLInputElement;
    const value = input.value.toLowerCase();
    const items = this.el.querySelectorAll('.phxsg-drawer-items__item');

    items.forEach((item) => {
      const text = item.textContent?.toLowerCase() || '';

      if (text.includes(value)) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });

    const hiddenItems = this.el.querySelectorAll('.phxsg-drawer-items__item.hidden');

    if (hiddenItems.length === items.length) {
      this.el.classList.add('phxsg-country-selector--empty');
    } else {
      this.el.classList.remove('phxsg-country-selector--empty');
    }
  }
}
